import { createAction, props } from "@ngrx/store";
import { CriterioDto, CriterioHijoDto, EscalaDto, MetaDto, UnidadBaseDto, UnidadMetaDto } from "../../models";

export const loadSuccess = createAction(
    '[Unidad Api] Load Success',
    props<{ escalas: EscalaDto[] }>()
);
export const loadFailure = createAction(
    '[Unidad Api] Load Failure',
    props<{ error: string }>()
);

export const loadUnidadMetasSuccess = createAction(
    '[Unidad Api] Load UnidadMetas Success',
    props<{ unidad: UnidadBaseDto, unidadMetas:  UnidadMetaDto[] }>()
);
export const loadUnidadMetasFailure = createAction(
    '[Unidad Api] Load UnidadMetas Failure',
    props<{ error: string }>()
  );

export const updateMetaSuccess = createAction(
  '[Unidad Api] Update Meta Success',
  props<{ meta: MetaDto }>()
);
export const updateMetaFailure = createAction(
  '[Unidad Api] Update Meta Failure',
  props<{ error: string }>()
);

export const updateCriterioSuccess = createAction(
  '[Unidad Api] Update Criterio Success',
  props<{ criterio: CriterioDto, unidadMetaId: number }>()
);
export const updateCriterioFailure = createAction(
  '[Unidad Api] Update Criterio Failure',
  props<{ error: string }>()
);

export const updateCriterioHijoSuccess = createAction(
  '[Unidad Api] Update CriterioHijo Success',
  props<{ criterio: CriterioHijoDto, unidadMetaId: number, criterioId: number }>()
);
export const updateCriterioHijoFailure = createAction(
  '[Unidad Api] Update CriterioHijo Failure',
  props<{ error: string }>()
);
